import {Injectable} from '@angular/core';
import {IGraphNode, IStatusNodeModelExt, ITaskStatusGraphData, TGraphType} from '../models/graph-kn.model-interfaces';
import {ContractStepModel} from '../../../models/contract.model';
export type ArrayOfTwo = readonly [number, number]

@Injectable({
    providedIn: 'root'
})
export class GraphKnHelperService {
    public stepsToAdd: ContractStepModel[] = [];
    getStatusData(node:IGraphNode) : IStatusNodeModelExt | ITaskStatusGraphData | undefined {
        let statusData
        switch (node.nodeType) {
            case 'BPStatus':
                statusData = node.bp_status_data
            break;
            case 'TaskStep':
                statusData = node.task_data
            break;
            case 'childBPStatus':
                statusData = node.bp_status_data
            break;
        }
        return statusData
    }
    swapTwoElements<T>(arrayToSwapOrg: T[], i1: number, i2: number): T[] {
        let arrayToSwap = [...arrayToSwapOrg];
        [arrayToSwap[i1], arrayToSwap[i2]] = [arrayToSwap[i2], arrayToSwap[i1]]
        return arrayToSwap
    }

    isContractOpen(state: string, graphType: TGraphType): boolean {
        const openStated = ['open']
        return openStated.includes(state) || graphType === 'bpLayer'
    }

    intersect2Ranges(a: ArrayOfTwo, b: ArrayOfTwo, ratio: number): boolean {
        return Math.abs(Math.max(a[0], a[1], b[1], b[0]) - Math.min(a[0], a[1], b[1], b[0])) < ((Math.abs(a[1] - a[0]) + Math.abs(b[1] - b[0])) * (1 - ratio))
    }

    shadeColor(color: string, percent: number): string {

        let R = parseInt(color.substring(1, 3), 16);
        let G = parseInt(color.substring(3, 5), 16);
        let B = parseInt(color.substring(5, 7), 16);

        R = (R * (100 + percent) / 100);
        G = (G * (100 + percent) / 100);
        B = (B * (100 + percent) / 100);

        R = (R < 255) ? R : 255;
        G = (G < 255) ? G : 255;
        B = (B < 255) ? B : 255;

        R = Math.round(R)
        G = Math.round(G)
        B = Math.round(B)

        var RR = ((R.toString(16).length == 1) ? "0" + R.toString(16) : R.toString(16));
        var GG = ((G.toString(16).length == 1) ? "0" + G.toString(16) : G.toString(16));
        var BB = ((B.toString(16).length == 1) ? "0" + B.toString(16) : B.toString(16));

        return "#" + RR + GG + BB;
    }
}